export default "__VITE_ASSET__9281a22c__"